<template>
  <div class="tips">

  </div>
</template>

<script>
export default {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tips {
    position: absolute;
    background-image: url("../assets/tips.png");
    left: 700px;
    bottom: 200px;
    width: 470px;
    height: 350px;
  }
</style>
